import React from 'react';
import { Slide, ToastContainer } from 'react-toastify';

export function CustomToastContainer() {
  return (
    <ToastContainer
      position="bottom-center" // One of top-right, top-center, top-left, bottom-right, bottom-center, bottom-left
      autoClose={2000} // Delay in ms to close the toast. If set to false, the notification need to be closed manualy
      hideProgressBar // Display or not the progress bar below the toast(remaining time)
      transition={Slide} // A reference to a valid react-transition-group/Transition component
      newestOnTop={false} // Display newest toast on top
      closeOnClick // Dismiss toast on click
      rtl={false} // Support right to left content
      pauseOnFocusLoss={false} // Pause the timer when the window loses focus
      draggable={false} // Allow toast to be draggable
      pauseOnHover={false} // Keep the timer running or not on hover
      toastClassName="custom-toast-container" // Add optional classes to the container
      closeButton={false} // A React Component to replace the default close button or false to hide the button
    />
  );
}
